import styled from "styled-components";

export const JBOptInReminderDialogDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    background:${props => props.theme.colors.backgroundMiddleDark};
    height: 306px;
    width: 333px;
`;
